import React from "react";
import {
  IonCard,
  IonCardContent,
  IonButton,
  IonRouterLink,
} from "@ionic/react";

import { useForm } from "react-hook-form";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router";

import { Breadcrumbs, Input } from "../../../components";

import { FORGOT_PASSWORD } from "../../../graphql/mutations/auth.mutation";

import toast from "react-hot-toast";

import "./login.styles.css";

const ForgetPassword = () => {
  const history = useHistory();
  const [forgotPasswordMutation] = useMutation(FORGOT_PASSWORD, {
    onCompleted(data: any) {
      if (data?.forgotCustomerPassword?.errors?.[0]?.message) {
        toast.error("Email not valid");
      } else {
        toast.success(
          "Richiesta di reimpostazione della password inviata con successo"
        );
        history.push("/login");
      }
    },
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const onFinish = (values: any) => {
    forgotPasswordMutation({ variables: values });
  };

  const breadcrumbEntries = [
    { title: "Password dimenticata" }
  ];

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      <div className="app-page-wrapper flex-center">
        <IonCard
          style={{
            width: "525px",
            padding: "20px",
          }}
        >
          <IonCardContent>
            <p
              className="card-title-text-large mb-default"
              style={{
                marginBottom: "20px",
              }}
            >
              Password dimenticata?
            </p>

            <form onSubmit={handleSubmit(onFinish)}>
              <Input
                name="Indirizzo Email"
                registerName="email"
                register={register}
                errors={errors}
                requiredMessage="Campo obbligatorio"
                pattern={{
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Indirizzo email non valido",
                }}
              />

              <div className="flex-justify-between">
                <IonRouterLink href="/login">
                  <span className="colored-link-nomargin">Torna al login</span>
                </IonRouterLink>

                <IonButton
                  shape="round"
                  slot="end"
                  size="default"
                  className="login-button"
                  type="submit"
                >
                  Invia
                </IonButton>
              </div>
            </form>
          </IonCardContent>
        </IonCard>
      </div>
    </div>
  );
};

export default ForgetPassword;
